import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { HEC_CONSTANTS } from '../../../../utilities/constants';

@Component({
  selector: 'kt-des-intrusctions',
  templateUrl: './des-intrusctions.component.html',
  styleUrls: ['./des-intrusctions.component.css']
})
export class DesIntrusctionsComponent implements OnInit {
  @Input() btnCancelText: string = 'Cancel';
  @Input() title: string;
  public type:string;
  public selectedRadio:any;
  public instruction:any;
  constructor(private dialogRef: MatDialogRef<DesIntrusctionsComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  private router: Router,) { }

  ngOnInit() {
    this.title = this.data ? this.data.title:'';
    this.type = this.data ? this.data.type:'';
    this.instruction = this.data ?this.data.instruction:'';

    // if (this.router.url == HEC_CONSTANTS.DES_URLS.LOCAL_DES) {
    // this.instruction = this.data ?this.data.instruction:'';
    //  }else if (this.router.url == HEC_CONSTANTS.DES_URLS.FOREIGN_DES) {
    //   this.instruction = '';
    // }
  }

  public dismiss(type) {
    this.dialogRef.close(false);
  }

  public accept() {
    console.log(this.selectedRadio)
    this.dialogRef.close(true);
  }
  public decline() {
    this.dialogRef.close('inst');
  }

  public readMore(){
    this.instruction = this.data ?this.data.instruction:'';

  }

  public readLess(){
    this.instruction = ''
  }

}
